import { render } from "./PrimaryButton.vue?vue&type=template&id=f3dd8226&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=f3dd8226&lang=css"
import "./PrimaryButton.vue?vue&type=style&index=1&id=f3dd8226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3dd8226"]])

export default __exports__